import { Card, CardContent } from "@/components/ui/card";
import { ChevronRight } from "lucide-react";
import { GalleryCardBaseProps } from "@/types/gallery";

export default function GalleryCard({
  title,
  description = "Descrizione non disponibile",
  onClick,
}: GalleryCardBaseProps) {
  return (
    <Card
      onClick={onClick}
      role="button"
      tabIndex={0}
      style={{
        backgroundColor: "var(--card)",
        color: "var(--card-foreground)",
      }}
      className="px-4 py-12 cursor-pointer elegant-border rounded-xl group relative h-[340px] flex flex-col shadow-sm hover:shadow-md transition"
    >
      <div className="side-border flex flex-col flex-grow">
        <CardContent className="h-full flex flex-col flex-grow">
          <h3 className="text-2xl font-bold mb-2 line-clamp-2 break-words min-h-[56px]">
            {title}
          </h3>

          <div className="flex-grow">
            <p className="text-md text-(--foreground) mb-0 line-clamp-4 break-words">
              {description}
            </p>
          </div>

          <div className="mt-auto">
            <div className="flex items-center font-semibold text-md text-(--card-foreground) group-hover:underline">
              Scopri di più! <ChevronRight className="ml-1 w-4 h-4" />
            </div>
          </div>
        </CardContent>
      </div>
    </Card>
  );
}
